const config: siteConfig = {
  // Softdigi endpoint
  // API_URL: "http://10.19.1.68:3005/api/",
  API_URL: "http://192.168.1.34:3006/api/",
  REDIRECT_SESSION_KEY: "",
  // CLIENT_URL: "http://127.0.0.1:5000",
  CLIENT_URL: "http://localhost:5000",
};

export default config;
